module.exports = UM;


//////////////////
// WEBPACK FOOTER
// external "UM"
// module id = 68
// module chunks = 60 61 62